import { css } from "@emotion/react";
import { ThemedCssCreator } from "../../../../config/emotion";

export const containerCss = css`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -4px;
`;
export const thumbCss = css`
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  border: 1px solid #eaeaea;
  margin-left: 4px;
  margin-top: 4px;
  width: 100px;
  height: 100px;
  padding: 4px;
  box-sizing: border-box;
  position: relative;
`;
export const thumbInnerCss = css`
  display: flex;
  min-width: 0;
  overflow: hidden;
  flex: 1;
`;
export const imgCss = css`
  display: block;
  width: auto;
  height: 100%;
`;
export const deleteButtonCss: ThemedCssCreator = (theme) => css`
  position: absolute;
  top: 3px;
  right: 3px;
  color: ${theme.colors.delete};
  transition: 200ms all;

  &:hover {
    transform: scale(1.2);
    cursor: pointer;
  }
`;
export const labelCss = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 12px;
  text-align: left;
  align-self: flex-end;
`;
